import FloatButton from "./FloatButton";

export default function AboutMeFloatButton() {
  return <div style={{ position: 'absolute', top: '605px', left: '1120px' }}>
    <FloatButton text="About Me" />
  </div>;
}
